import { render } from "./FooterComponent.vue?vue&type=template&id=60cbdb0e"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\hhsiao\\Downloads\\Mamba\\cloud-business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__